import { lt } from '@mews/framework';
import { Stack, Typography } from '@optimus-web/core';
import { useSelectedRateGroupsContext } from '../hooks';
import { CentralRateGroupSelectField } from './CentralRateGroupSelectField';

export const LinkStepFields = () => {
    const selectedRateGroups = useSelectedRateGroupsContext();

    return (
        <Stack spacing="50" vertical>
            {selectedRateGroups[0] ? (
                <CentralRateGroupSelectField serviceKey={selectedRateGroups[0].serviceKey} required />
            ) : null}
            <Typography textStyle="bodyMedium" variant="secondary" as="div">
                {lt('LinkCentralReviewChangesInfoMessage')}
            </Typography>
        </Stack>
    );
};
